import { CommonModule } from '@angular/common';
import { Component, HostBinding, inject, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { Store } from '@ngxs/store';
import type { routeItem } from './route-item.type';

@Component({
  selector: 'dtis-slim-navbar',
  imports: [CommonModule, RouterModule, TranslocoModule, MatIconModule],
  templateUrl: './slim-sidebar.component.html',
  styleUrls: ['./slim-sidebar.component.css'],
})
export class SlimNavbarComponent {
  /**
   *
   */
  store = inject(Store);

  /**
   * Host binding for expanded CSS class
   */
  @HostBinding('class.expanded')
  get isExpanded() {
    return this.expanded();
  }

  /**
   *
   */
  expanded = input(false);
  settingsRoute = input('settings');
  /**
   *
   */
  routes = input<routeItem[]>([]);
}
